import { FormComponent } from './component'
import { UUID } from '@/plugins/common'
import Button from './button'

export default class Definition {
  constructor (args = {}) {
    this.name = args.name || ''
    this.id = args.id || UUID.create()
    this.containerNumbers = args.containerNumbers || 4
    this.form = args.id ? FormComponent.load(args.form.form) : FormComponent.create()
    this.alias = this.form.alias
    this.buttons = args.buttons || [new Button({name: '确定', type: 'comfirm', formDefinitionId: this.id}), new Button({name: '取消', type: 'cancel', formDefinitionId: this.id})]
    // 备注信息
    this.comment = ''
    // js脚本路径
    this.jsPath = args.jsPath || ''
  }
}



// WEBPACK FOOTER //
// ./src/store/form/definition.js